import { render, staticRenderFns } from "./CAHG1140.vue?vue&type=template&id=52242bba"
import script from "./CAHG1140Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAHG1140Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports